import React from "react";
import { EmojiSuggester } from "../EmojiSuggester/EmojiSuggester";
import { getEmojiSuggesterMatchOffset } from "../../plugins";
export const EmojiSuggesterPluginView = ({ view, suggesterCallbacksRegistry }) => {
    const matchOffset = getEmojiSuggesterMatchOffset(view.state);
    return (React.createElement(EmojiSuggester, { view: view, suggesterCallbacksRegistry: suggesterCallbacksRegistry, matchOffset: matchOffset }));
};
